import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmInfos } from '../../lawFirm.types';
import {
  DomainFlattened,
  Juridiction,
  Ville,
} from '../../../entity/entity.types';
import { LawFirmDescription } from '../description/LawFirmDescription';
import { LawFirmClients } from '../LawFirmClients';
import { FirmTopDecisions } from '../FirmTopDecisions';
import { LawFirmTop } from '../header/LawFirmTop';
import { Offices } from './Offices';
import { LawFirmCases } from '../LawFirmCases';
import { LawFirmHeader } from './LawFirmHeader';
import { UserContextType } from '../../../user/user.types';
import { PageCenter } from '../../../components/page/Page';
import { LoaderWithText } from '../../../components/loader/LoaderWithText';
import {
  EntityCardContainer,
  EntityCardHeader,
  EntityCardItem,
} from '../../../entity/components/EntityCardComponents';

type Props = {
  lawFirmInfos: LawFirmInfos;
  loggedIn: UserContextType['loggedIn'];
  experience: {
    domains: Array<DomainFlattened>;
    juridictions: Array<Juridiction>;
    villes: Array<Ville>;
    decisionCount: number;
  };
  loaded: boolean;
  allDecisionsLink: string;
};

export class LawFirm extends React.Component<Props> {
  componentDidMount() {
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('showNav', { detail: true }));
    }, 1);
  }

  render() {
    const {
      allDecisionsLink,
      lawFirmInfos: { name, lawOfficeIdGroup, offices, dateRadiation },
      loggedIn,
      experience,
      experience: { decisionCount, domains, juridictions, villes },
      loaded,
    } = this.props;

    if (!loaded) {
      return (
        <PageCenter>
          <EntityCardHeader>
            <LawFirmTop name={name} />
          </EntityCardHeader>
          <EntityCardContainer>
            <EntityCardItem>
              <LoaderWithText>
                <FormattedMessage id="law-firm/page/firm/LawFirm.tsx/1" />
              </LoaderWithText>
            </EntityCardItem>
          </EntityCardContainer>
        </PageCenter>
      );
    }

    return (
      <PageCenter>
        <LawFirmHeader
          firmName={name}
          decisionCount={decisionCount}
          dateRadiation={dateRadiation}
          allDecisionsLink={allDecisionsLink}
          lawOfficeIdGroup={lawOfficeIdGroup}
        />
        <FirmTopDecisions
          lawOfficeIdGroup={lawOfficeIdGroup}
          decisionCount={decisionCount}
          allDecisionsLink={allDecisionsLink}
          firmName={name}
        />
        <Offices
          offices={offices}
          LawFirmName={name}
          lawOfficeIdGroup={lawOfficeIdGroup}
        />
        <LawFirmDescription
          pageName={`le cabinet ${name}`}
          hasExperience={
            domains.length > 0 || juridictions.length > 0 || villes.length > 0
          }
          decisionCount={decisionCount}
        />
        {(domains.length > 0 ||
          juridictions.length > 0 ||
          villes.length > 0) && (
          <LawFirmCases
            experience={experience}
            lawOfficeIdGroup={lawOfficeIdGroup}
            lawFirmName={name}
          />
        )}
        <LawFirmClients
          lawOfficeIdGroup={lawOfficeIdGroup}
          name={name}
          loggedIn={loggedIn}
          decisionCount={decisionCount}
        />
      </PageCenter>
    );
  }
}
